var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "15.000000pt",
    height: "15.000000pt",
    viewBox: "0 0 48.000000 48.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,48.000000) scale(0.100000,-0.100000)",
    fill: "#FF5722",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80 240 l0 -210 160 0 160 0 0 158 0 158 -53 52 -53 52 -107 0 -107 0 0 -210z m265 150 l49 -50 -52 0 -52 0 0 50 c0 28 1 50 3 50 1 0 25 -22 52 -50z m-90 -131 c0 -45 18 -67 58 -71 24 -2 32 -8 32 -23 0 -22 -40 -34 -57 -17 -15 15 -69 -6 -91 -35 -23 -29 -57 -31 -57 -3 0 12 10 25 26 32 33 15 55 68 45 105 -11 38 -3 55 23 51 17 -2 21 -10 21 -39z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.0f7122c637b363226a5ba65fc0efdd18.svg";
export { ForwardRef as ReactComponent };